module.exports = __webpack_public_path__ + "static/media/logo.02ad94e5.png";